var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJetPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_4426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.264 476.602H853.393V598.779L780.204 550.404L673.861 595.677L566.264 550.403L473.058 636.61L372.342 665.14L327.928 628.548L292.897 575.831L259.742 607.462L185.926 546.062L134.63 553.505L77.08 504.509L2.63965 485.904L3.264 476.602Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 476.602V477.203H852.787V597.655L780.267 549.722L673.859 595.023L566.139 549.697L472.75 636.071L372.483 664.474L328.385 628.142L293.001 574.896L259.714 606.653L186.108 545.428L134.816 552.869L77.3663 503.961L3.27796 485.443L3.86903 476.642L3.26384 476.602V477.203V476.602L2.65865 476.562L2 486.364L76.7934 505.058L134.445 554.14L185.745 546.697L259.769 608.27L292.792 576.767L327.47 628.953L372.201 665.805L473.364 637.148L566.39 551.109L673.861 596.331L780.141 551.085L854 599.903V476H2.69597L2.65865 476.562L3.26384 476.602Z",
    fill: "#384252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 476.602V477.203H852.787V597.655L780.267 549.722L673.859 595.023L566.139 549.697L472.75 636.071L372.483 664.474L328.385 628.142L293.001 574.896L259.714 606.653L186.108 545.428L134.816 552.869L77.3663 503.961L3.27796 485.443L3.86903 476.642L3.26384 476.602ZM3.26384 476.602V477.203V476.602ZM3.26384 476.602L2.65865 476.562L2 486.364L76.7934 505.058L134.445 554.14L185.745 546.697L259.769 608.27L292.792 576.767L327.47 628.953L372.201 665.805L473.364 637.148L566.39 551.109L673.861 596.331L780.141 551.085L854 599.903V476H2.69597L2.65865 476.562L3.26384 476.602Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3058_4426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.7198 452.57C69.7198 452.57 69.5698 394.48 70.1698 388.78C70.7698 385.25 72.3298 383.19 76.7698 380.78L244.58 307.98C246.226 307.626 247.938 307.729 249.53 308.28C251.406 309.547 252.965 311.231 254.084 313.2C255.203 315.168 255.852 317.369 255.98 319.63V327.74",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7198 452.57C69.7198 452.57 69.5698 394.48 70.1698 388.78C70.7698 385.25 72.3298 383.19 76.7698 380.78L244.58 307.98C246.226 307.626 247.938 307.729 249.53 308.28C251.406 309.547 252.965 311.231 254.084 313.2C255.203 315.168 255.852 317.369 255.98 319.63V327.74",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.85 488.43H599.69V625.13H650.85V488.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.02 625.2L611.02 625.62V687.39L619.51 691L620.36 689.51L630.55 689.94L631.61 690.79L638.4 687.79L639.04 686.52L639.65 625.36H650.46V768.73H600.07L600.02 625.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.89 625.63H608.56L608.64 687.88L625.26 692.27L642.26 686.49V625.59H650.52V768.86H599.98L599.9 625.63H599.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.93 498.7V768.85H650.54V488.91",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.93 498.7V768.85H650.54V488.91",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.22 508.44V735.26V508.44Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.22 508.44V735.26",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.96 734.86L551.96 740.26L599.96 743.86V734.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.96 754.07L551.96 759.47L599.96 763.07V754.07Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.69 754.07L698.69 759.47L650.69 763.07V754.07Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.69 734.86L698.69 740.26L650.69 743.86V734.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.1 469.77H597.55V472.47H600.1V469.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.31 469.77H616.76V472.47H619.31V469.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.02 469.77H631.47V472.47H634.02V469.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.68 469.77H651.13V472.47H653.68V469.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.83 457.47H651.28V460.17H653.83V457.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.17 457.47H631.62V460.17H634.17V457.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.31 457.32H616.76V460.02H619.31V457.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.25 457.62H597.7V460.32H600.25V457.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.52 459.88V444.42H642.14V460.18L608.52 459.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.43 460.02L596.54 469.76H654.09V460.02H596.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.37 464.94L654.2 465.05L596.37 464.94Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.37 464.94L654.2 465.05",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.75 427.71V424.15H675.05V427.71H670.75Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.26 426.57H652.92L654.3 429.01H667.04V427.74H678.93L679.41 429.81H692.84L689.07 437.24H679.52L678.19 438.73H667.63L666.63 437.46H653.84V440.86H643.37L643.26 426.63V426.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.18 444.52L643.33 444.57V422.81H606.26L606.18 444.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.07 422.72H612.52V425.42H615.07V422.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.93 414.23H608.38V416.93H610.93V414.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.4 414.07H640.85V416.77H643.4V414.07Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.04 422.56H635.49V425.26H638.04V422.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.89 416.54V423.07H645.84V416.54H604.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605 419.63H645.76H605Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605 419.63H645.76",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.25 428.9C653.483 431.724 653.411 434.692 654.04 437.55L654.25 428.9Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.25 428.9C653.483 431.724 653.411 434.692 654.04 437.55",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.93 428.96C666.389 431.818 666.389 434.752 666.93 437.61V428.96Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.93 428.96C666.389 431.818 666.389 434.752 666.93 437.61",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.45 429.96C678.928 432.318 678.928 434.762 679.45 437.12V429.96Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.45 429.96C678.928 432.318 678.928 434.762 679.45 437.12",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.47 416.53V396.53H613.98V392.63H633.84V396.63H630.05V416.56H617.47V416.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.04 392.63V172.7V392.63Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.04 392.63V172.7",
    stroke: "#F7F9F9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5002 456.73L70.2202 388.51C70.3282 387.441 70.6644 386.407 71.2061 385.479C71.7478 384.551 72.4824 383.75 73.3602 383.13C75.6702 381.13 83.1202 378.18 83.1202 378.18L245.53 307.63L250.33 308.68L255.28 314.38L255.73 323.69L253.33 391.23L240.72 392.43L153.21 452.32L131.09 456.25L69.4902 456.73H69.5002Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.71 472.73H54.7402V475.7H230.71V472.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.39 445.34V431.01L52.46 433.56V446.02L55.39 445.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.15 174.04H288.89L289 169.16H287.33C286.993 167.669 286.993 166.121 287.33 164.63H288.93L288.86 162.38L311.47 162.49V174.06L295.15 174.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.58 124.44H306.58L287.34 161.32L288.83 162.32H577.44L565.58 124.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.45 124.46L287.84 159.8L450.01 159.69V124.35L306.45 124.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.42 124.46H449.95V159.63H576.68L565.43 124.46H565.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.84 241.44C620.1 222.75 623.4 184.54 624.3 172.44C622.57 129.89 608.46 103.44 608.46 103.44C603.325 98.8149 597.298 95.2893 590.75 93.0801L565.46 121.73L565.54 125.11L601.04 236.03C602.135 238.004 603.777 239.619 605.77 240.68C606.751 241.089 607.79 241.342 608.85 241.43L608.84 241.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.67 159.8H287.84H576.67Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.67 159.8H287.84",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.72 142.08L477.33 140.91L527.33 440.91L523.08 441.23L473.72 142.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.59 185.91L483.84 182.83L484.9 186.23L465.16 189.1L464.63 185.92L464.59 185.91Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.03 163.2L520.03 166.81L476.41 173.92L475.99 170.63L519.08 163.2H519.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.42 411.23L522.01 408.68L521.27 404.54L500.89 407.41L501.42 411.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.49 175.2L461.41 180.45L440.71 180.5L443.15 175.14L458.49 175.19V175.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.5 162.17V167.95L443.08 170.95L443.16 175.08L448.26 177.59H453.55L458.5 175.08L458.42 170.8L466.3 168.4V162.13H435.49L435.5 162.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.05 170.9C455.05 172.009 454.61 173.072 453.826 173.856C453.042 174.64 451.979 175.08 450.87 175.08C449.762 175.08 448.699 174.64 447.915 173.856C447.131 173.072 446.69 172.009 446.69 170.9C446.69 169.791 447.131 168.728 447.915 167.944C448.699 167.16 449.762 166.72 450.87 166.72C451.979 166.72 453.042 167.16 453.826 167.944C454.61 168.728 455.05 169.791 455.05 170.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.78 177.63V180.39H452.78V177.47L448.69 177.63H448.78Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.06 266.27H481.52V268.27H479.08V271.88H477.08V266.25L477.06 266.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.89 182.4L462.37 182.17L507.02 449.57L495.02 449.49L450.84 182.39L450.89 182.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.67 181.33L507.84 449.14L505.61 449.46L460.84 180.2L463.69 181.34L463.67 181.33Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.12 334.63L476.96 334.95L476.85 340.15L474.2 340.04V336.96H471.01L471.12 334.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.73 450.09L449.15 182.52L451.51 181.58L496.17 449.63L493.72 450.09H493.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.38 180.19L438.11 181.68L438 184.12H463.21V181.57L462.04 180.08L439.38 180.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.67 212.63H423.67L437.78 184.34L452.04 184.11L456.67 212.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.36 191.22C447.36 191.584 447.252 191.94 447.05 192.242C446.847 192.545 446.56 192.781 446.224 192.92C445.888 193.059 445.518 193.096 445.161 193.025C444.804 192.954 444.476 192.778 444.219 192.521C443.961 192.264 443.786 191.936 443.715 191.579C443.644 191.222 443.68 190.852 443.82 190.516C443.959 190.18 444.195 189.892 444.497 189.69C444.8 189.488 445.156 189.38 445.52 189.38C446.008 189.38 446.476 189.574 446.821 189.919C447.166 190.264 447.36 190.732 447.36 191.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.59 197.37C444.59 197.734 444.482 198.09 444.28 198.392C444.078 198.695 443.791 198.931 443.454 199.07C443.118 199.209 442.748 199.246 442.391 199.175C442.034 199.104 441.706 198.928 441.449 198.671C441.192 198.414 441.017 198.086 440.946 197.729C440.875 197.372 440.911 197.002 441.05 196.666C441.19 196.33 441.425 196.042 441.728 195.84C442.031 195.638 442.386 195.53 442.75 195.53C443.238 195.53 443.706 195.724 444.051 196.069C444.396 196.414 444.59 196.882 444.59 197.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.73 203.53C441.73 203.894 441.622 204.25 441.42 204.552C441.218 204.855 440.93 205.091 440.594 205.23C440.258 205.369 439.888 205.406 439.531 205.335C439.174 205.264 438.846 205.088 438.589 204.831C438.331 204.574 438.156 204.246 438.085 203.889C438.014 203.532 438.051 203.162 438.19 202.826C438.329 202.49 438.565 202.202 438.868 202C439.17 201.798 439.526 201.69 439.89 201.69C440.378 201.69 440.846 201.884 441.191 202.229C441.536 202.574 441.73 203.042 441.73 203.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.03 209.63C439.03 209.994 438.922 210.35 438.719 210.652C438.517 210.955 438.23 211.191 437.894 211.33C437.558 211.469 437.188 211.506 436.831 211.435C436.474 211.364 436.146 211.188 435.889 210.931C435.631 210.674 435.456 210.346 435.385 209.989C435.314 209.632 435.35 209.262 435.49 208.926C435.629 208.59 435.865 208.302 436.167 208.1C436.47 207.898 436.826 207.79 437.19 207.79C437.678 207.79 438.146 207.984 438.491 208.329C438.836 208.674 439.03 209.142 439.03 209.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.84 203.75C432.84 204.114 432.732 204.47 432.53 204.772C432.328 205.075 432.041 205.311 431.704 205.45C431.368 205.589 430.998 205.626 430.641 205.555C430.284 205.484 429.956 205.308 429.699 205.051C429.442 204.794 429.267 204.466 429.196 204.109C429.125 203.752 429.161 203.382 429.3 203.046C429.44 202.71 429.675 202.422 429.978 202.22C430.281 202.018 430.636 201.91 431 201.91C431.242 201.91 431.481 201.958 431.704 202.05C431.928 202.142 432.13 202.278 432.301 202.449C432.472 202.62 432.608 202.823 432.7 203.046C432.793 203.269 432.84 203.508 432.84 203.75Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.84 209.53C429.84 209.894 429.732 210.25 429.53 210.552C429.328 210.855 429.041 211.091 428.704 211.23C428.368 211.369 427.998 211.406 427.641 211.335C427.284 211.264 426.956 211.088 426.699 210.831C426.442 210.574 426.267 210.246 426.196 209.889C426.125 209.532 426.161 209.162 426.3 208.826C426.44 208.49 426.675 208.202 426.978 208C427.281 207.798 427.636 207.69 428 207.69C428.488 207.69 428.956 207.884 429.301 208.229C429.646 208.574 429.84 209.042 429.84 209.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.66 197.75C435.66 198.114 435.553 198.47 435.35 198.772C435.148 199.075 434.861 199.311 434.525 199.45C434.188 199.589 433.818 199.626 433.461 199.555C433.105 199.484 432.777 199.308 432.519 199.051C432.262 198.794 432.087 198.466 432.016 198.109C431.945 197.752 431.981 197.382 432.121 197.046C432.26 196.71 432.496 196.422 432.798 196.22C433.101 196.018 433.457 195.91 433.82 195.91C434.308 195.91 434.776 196.104 435.122 196.449C435.467 196.794 435.66 197.262 435.66 197.75Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.66 191.89C438.66 192.254 438.553 192.61 438.35 192.912C438.148 193.215 437.861 193.451 437.525 193.59C437.188 193.729 436.818 193.766 436.461 193.695C436.105 193.624 435.777 193.448 435.519 193.191C435.262 192.934 435.087 192.606 435.016 192.249C434.945 191.892 434.981 191.522 435.121 191.186C435.26 190.85 435.496 190.562 435.798 190.36C436.101 190.158 436.457 190.05 436.82 190.05C437.308 190.05 437.776 190.244 438.122 190.589C438.467 190.934 438.66 191.402 438.66 191.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.21 212.49L356.11 394.26L342.23 394.64L424.03 212.57L438.21 212.49Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.35 394.37L371.84 449.73H241.5L241.65 394.34H357.35V394.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.84 475.83L493.08 448.83H230.25V475.83L495.85 475.88L495.84 475.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.47 449.5V473.22H495.69L492.99 449.35L230.47 449.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.4 448.97L507.51 475.78H495.71L493.35 448.78L507.35 448.97H507.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.62 459.11V473.33V459.11Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.62 459.11V473.33",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.95 459.17V473.63V459.17Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.95 459.17V473.63",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.73 456.33V426.24H145.36V456.48L130.73 456.33Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9598 463.63H52.4099V467.29H49.8398V420.29H52.5499L52.3398 460.41H54.9898V463.59L54.9598 463.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9704 433.38C49.9704 433.8 52.9704 433.22 52.9704 433.22C52.9704 433.22 55.6804 431.47 56.1004 429.45C56.1704 428.45 56.9904 429.16 56.3104 426.45C56.4204 425.97 54.9304 425.45 54.9304 425.45C54.6026 427 53.9178 428.451 52.9304 429.69C51.7803 430.753 50.369 431.491 48.8404 431.83C48.8404 431.83 48.4104 433.05 49.9504 433.37L49.9704 433.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7598 445.48H54.9598L54.9098 447.82H49.9098L49.7598 445.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.38 426.31V451.68H145.29V426.16L135.38 426.31Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.54 454.38H132.36V456.61H135.54V454.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8 454.12H144.62V456.35H147.8V454.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.09 451.09H136.08V455.02H144.09V451.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.98 448.07H137.46V450.72H142.98V448.07Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7305 451.37L55.0605 451.26V456.26H52.7305V451.38V451.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6303 451.34L63.1303 452.61V456.01H59.3604L59.6303 451.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.17 414.41C113.17 414.744 113.071 415.071 112.885 415.349C112.7 415.627 112.436 415.843 112.127 415.971C111.818 416.099 111.478 416.133 111.15 416.068C110.823 416.002 110.521 415.841 110.285 415.605C110.049 415.369 109.888 415.068 109.823 414.74C109.757 414.412 109.791 414.072 109.919 413.763C110.047 413.454 110.263 413.19 110.541 413.005C110.819 412.819 111.146 412.72 111.48 412.72C111.928 412.72 112.358 412.898 112.675 413.215C112.992 413.532 113.17 413.962 113.17 414.41Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7599 428.82C98.7599 429.154 98.6608 429.481 98.4751 429.759C98.2894 430.037 98.0254 430.253 97.7166 430.381C97.4078 430.509 97.068 430.543 96.7402 430.478C96.4124 430.412 96.1112 430.251 95.8749 430.015C95.6385 429.779 95.4776 429.478 95.4124 429.15C95.3471 428.822 95.3806 428.482 95.5085 428.173C95.6364 427.864 95.8531 427.601 96.131 427.415C96.4089 427.229 96.7356 427.13 97.0699 427.13C97.5181 427.13 97.9479 427.308 98.2649 427.625C98.5818 427.942 98.7599 428.372 98.7599 428.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.99 340.03L245.9 326.63H248.5L249.08 327.9H261.55L263.3 325.78L277.68 325.83L278.96 327.83L292.22 327.74L292.84 325.42L308.51 325.3V327.74H320.56L320.98 326.63L322.41 326.84L325.33 342.07L325.12 389.51L248.23 389.4L248.44 357.32L243.98 339.99L243.99 340.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.65 452.11H152.93L240.49 392.36H242.49",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.65 452.11H152.93L240.49 392.36H242.49",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.84 459.22C189.84 459.22 207.25 452.22 212.84 438.84L223.84 383.12C224.533 380.835 225.826 378.778 227.585 377.163C229.344 375.548 231.504 374.435 233.84 373.94L242.33 373.83",
    stroke: "#F7F9F9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.3 459.17V473.5H54.8398V459.44L230.3 459.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.36 473.5V454.87V473.5Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.36 473.5V454.87",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.23 450.52V463.04V450.52Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.23 450.52V463.04",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.19 389.17V394.05L329.96 393.94V389.06L242.19 389.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.11 389.06V394.06V389.06Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.11 389.06V394.06",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.93 386.51H272.85V389.06H275.93V386.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.63 389.17L291.96 358.29L308.41 358.08L324.33 389.08L277.63 389.19V389.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.14 386.51H286.06V389.06H289.14V386.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.31 325.38V338.43H306.07V325.48L296.31 325.37V325.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.35 386.51H299.27V389.06H302.35V386.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.55 386.51H312.47V389.06H315.55V386.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.76 386.51H325.68V389.06H328.76V386.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.91 386.51H242.83V389.06H245.91V386.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.61 372.72L242.4 375.59L246.55 377.73H254.87L266.57 379.73V370.73L268.69 368.82L272.83 368.71L268.69 368.39L268.07 366.94H266.25L265.04 368.43H262.84V371.06H263.84V375.63L254.92 375.34L252.27 374.28L251.04 372.63L246.32 372.58L242.61 372.74V372.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.06 368.46H244.3V371.27H247.06V368.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.96 365.87V372.34H250.73V366.02L246.96 365.86V365.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.27 352.39C269.27 356.382 267.684 360.21 264.862 363.032C262.039 365.854 258.211 367.44 254.22 367.44C250.228 367.44 246.4 365.854 243.578 363.032C240.756 360.21 239.17 356.382 239.17 352.39C239.17 348.399 240.756 344.571 243.578 341.748C246.4 338.926 250.228 337.34 254.22 337.34C258.211 337.34 262.039 338.926 264.862 341.748C267.684 344.571 269.27 348.399 269.27 352.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.84 371.29H264.19L264.4 367.2L247.05 367.09L246.84 371.28V371.29Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.57 352.52C267.57 356.024 266.179 359.384 263.701 361.861C261.224 364.338 257.864 365.73 254.36 365.73C250.857 365.73 247.497 364.338 245.02 361.861C242.542 359.384 241.15 356.024 241.15 352.52C241.15 349.017 242.542 345.657 245.02 343.179C247.497 340.702 250.857 339.31 254.36 339.31C257.864 339.31 261.224 340.702 263.701 343.179C266.179 345.657 267.57 349.017 267.57 352.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.54 352.5C266.586 354.126 266.306 355.744 265.716 357.259C265.127 358.775 264.239 360.157 263.105 361.323C261.972 362.489 260.616 363.416 259.118 364.049C257.621 364.683 256.011 365.009 254.385 365.009C252.758 365.009 251.149 364.683 249.651 364.049C248.153 363.416 246.797 362.489 245.664 361.323C244.53 360.157 243.643 358.775 243.053 357.259C242.463 355.744 242.183 354.126 242.23 352.5C242.32 349.337 243.641 346.333 245.91 344.128C248.18 341.922 251.22 340.689 254.385 340.689C257.549 340.689 260.589 341.922 262.859 344.128C265.128 346.333 266.449 349.337 266.54 352.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.59 352.47C265.59 355.432 264.413 358.274 262.318 360.368C260.224 362.463 257.382 363.64 254.42 363.64C251.458 363.64 248.616 362.463 246.522 360.368C244.427 358.274 243.25 355.432 243.25 352.47C243.25 351.003 243.539 349.551 244.1 348.195C244.662 346.84 245.484 345.609 246.522 344.572C247.559 343.534 248.79 342.712 250.145 342.15C251.501 341.589 252.953 341.3 254.42 341.3C255.887 341.3 257.339 341.589 258.695 342.15C260.05 342.712 261.281 343.534 262.318 344.572C263.356 345.609 264.178 346.84 264.74 348.195C265.301 349.551 265.59 351.003 265.59 352.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.36 352.45C263.4 353.639 263.2 354.824 262.773 355.935C262.345 357.045 261.699 358.058 260.871 358.914C260.044 359.769 259.054 360.449 257.958 360.914C256.863 361.378 255.685 361.618 254.495 361.618C253.305 361.618 252.127 361.378 251.032 360.914C249.936 360.449 248.946 359.769 248.119 358.914C247.291 358.058 246.645 357.045 246.217 355.935C245.79 354.824 245.59 353.639 245.63 352.45C245.59 351.261 245.79 350.076 246.217 348.965C246.645 347.855 247.291 346.842 248.119 345.986C248.946 345.131 249.936 344.451 251.032 343.986C252.127 343.522 253.305 343.282 254.495 343.282C255.685 343.282 256.863 343.522 257.958 343.986C259.054 344.451 260.044 345.131 260.871 345.986C261.699 346.842 262.345 347.855 262.773 348.965C263.2 350.076 263.4 351.261 263.36 352.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3 353.14C282.34 354.293 282.147 355.443 281.732 356.52C281.318 357.597 280.691 358.58 279.889 359.41C279.087 360.24 278.127 360.9 277.064 361.35C276.002 361.801 274.86 362.033 273.705 362.033C272.551 362.033 271.409 361.801 270.347 361.35C269.284 360.9 268.324 360.24 267.522 359.41C266.72 358.58 266.093 357.597 265.679 356.52C265.264 355.443 265.071 354.293 265.11 353.14C265.071 351.987 265.264 350.837 265.679 349.76C266.093 348.683 266.72 347.7 267.522 346.87C268.324 346.04 269.284 345.381 270.347 344.93C271.409 344.479 272.551 344.247 273.705 344.247C274.86 344.247 276.002 344.479 277.064 344.93C278.127 345.381 279.087 346.04 279.889 346.87C280.691 347.7 281.318 348.683 281.732 349.76C282.147 350.837 282.34 351.987 282.3 353.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.55 331.27L259.06 336.27V337.97H249.45V336.22L254.54 331.28L254.55 331.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.64 336.1L244.78 336.36L243.98 338.36L242.34 337.36L240.54 339.43L239.48 339.59L238.48 338.48L237.31 339.86L233.81 336.2L234.07 334.29L245.89 330.63L248.97 331.53L253.97 331.72L249.64 336.1Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.17 359.03L279.81 359.14L291.17 359.03Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.17 359.03L279.81 359.14",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.28 325.17L298.23 323.17H296.96L298.34 321.63L302.48 321.52L303.97 323.11H302.54V325.11H298.29L298.28 325.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.26 347.25H279.84H290.26Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.26 347.25H279.84",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.48 345.87L327.84 341.87L330.07 353.63L294.51 363.63",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.48 345.87L327.84 341.87L330.07 353.63L294.51 363.63",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.84 330.48L357.38 328.36L312.48 194.36L306.11 196.91L349.84 330.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.6 177.54H294.51L295.04 170.85C295.78 167.85 299.6 168.52 299.6 168.52L299.81 172.13C299.259 172.916 298.946 173.845 298.909 174.804C298.872 175.763 299.112 176.713 299.6 177.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.84 175.35L309.84 172.16L305.24 167.28C302.8 165.43 300.24 168.28 300.24 168.28L302.33 171.23C303.254 171.497 304.081 172.025 304.713 172.75C305.344 173.476 305.753 174.368 305.89 175.32L305.84 175.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.72 177.33L305.01 204.18L311.06 211.72L299.6 177.33H294.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.26 172.47L318.13 200.13L317.81 209.79L306.35 175.4L310.26 172.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.6 176.79L305.84 196.85L310.62 199.72L312.74 194.09L305.74 174.09C303.94 170.69 298.31 169.95 299.58 176.74L299.6 176.79Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.84 183.91L308.42 181.68L301.84 183.91Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.84 183.91L308.42 181.68",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.07 193.71L311.81 191.44L305.07 193.71Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.07 193.71L311.81 191.44",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.9 164.42C289.6 165.944 290.845 167.15 292.39 167.8L300.95 167.91L303.16 166.86L309.76 166.97L309.84 162.43",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.9 164.42C289.6 165.944 290.845 167.15 292.39 167.8L300.95 167.91L303.16 166.86L309.76 166.97L309.84 162.43",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.65 167.8V173.99V167.8Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.65 167.8V173.99",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.69 317.36L377.42 314.79C377.42 314.79 377.08 314.1 376.73 314.07L373.21 314.37C373.04 314.471 372.892 314.606 372.775 314.766C372.659 314.925 372.575 315.107 372.53 315.3L372.85 317.94L377.69 317.34V317.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.21 323.34L372.91 318.09L377.86 317.49C377.86 317.49 371.51 279.14 371.41 277.86C371.57 277.06 372.35 273.86 374.53 272.49C376.559 272.098 378.65 272.162 380.65 272.68C380.65 272.68 399.65 283.18 408.86 299.17L409.39 312.08H415.84C420.64 321.84 424.1 332.19 423.19 354.56L418.09 354.41L420.09 371.52C411.18 395.69 400.84 402.74 400.84 402.74C399.79 403.79 395.59 403.79 395.59 403.79C394.051 403.137 392.744 402.036 391.84 400.63L385.24 360.25L379.39 360.85C379.39 344.64 373.24 323.33 373.24 323.33L373.21 323.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.35 369.96L290.16 358.71C287.7 351.01 288.38 354.03 289.4 347.33L294.94 337.06L296.43 336.42L417.32 316.63C417.32 316.63 422.73 326.05 423.05 349.29L300.36 369.99L300.35 369.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84 283.11C386.84 283.822 386.629 284.518 386.233 285.11C385.837 285.702 385.275 286.163 384.617 286.436C383.959 286.708 383.236 286.78 382.537 286.641C381.839 286.502 381.198 286.159 380.694 285.656C380.191 285.152 379.848 284.511 379.709 283.812C379.57 283.114 379.641 282.39 379.914 281.732C380.186 281.075 380.648 280.512 381.24 280.117C381.832 279.721 382.528 279.51 383.24 279.51C384.194 279.51 385.11 279.889 385.785 280.564C386.46 281.24 386.84 282.155 386.84 283.11Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.47 283.26C384.47 283.497 384.4 283.729 384.268 283.927C384.136 284.124 383.949 284.278 383.73 284.369C383.51 284.46 383.269 284.483 383.036 284.437C382.803 284.391 382.59 284.276 382.422 284.109C382.254 283.941 382.14 283.727 382.093 283.494C382.047 283.261 382.071 283.02 382.162 282.801C382.252 282.582 382.406 282.394 382.604 282.262C382.801 282.13 383.033 282.06 383.27 282.06C383.589 282.06 383.894 282.187 384.119 282.412C384.344 282.637 384.47 282.942 384.47 283.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.64 311.48C405.64 312.192 405.429 312.888 405.034 313.48C404.638 314.072 404.076 314.533 403.418 314.806C402.76 315.078 402.036 315.15 401.338 315.011C400.64 314.872 399.998 314.529 399.495 314.025C398.991 313.522 398.649 312.881 398.51 312.182C398.371 311.484 398.442 310.76 398.714 310.102C398.987 309.444 399.448 308.882 400.04 308.487C400.632 308.091 401.328 307.88 402.04 307.88C402.995 307.88 403.911 308.259 404.586 308.934C405.261 309.609 405.64 310.525 405.64 311.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.23 311.63C403.23 311.867 403.16 312.099 403.028 312.297C402.896 312.494 402.709 312.648 402.489 312.739C402.27 312.829 402.029 312.853 401.796 312.807C401.563 312.761 401.349 312.646 401.182 312.478C401.014 312.311 400.899 312.097 400.853 311.864C400.807 311.631 400.831 311.39 400.921 311.171C401.012 310.951 401.166 310.764 401.363 310.632C401.561 310.5 401.793 310.43 402.03 310.43C402.348 310.43 402.654 310.556 402.879 310.781C403.104 311.006 403.23 311.312 403.23 311.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.27 314.63C386.27 315.342 386.059 316.038 385.664 316.63C385.268 317.222 384.706 317.684 384.048 317.956C383.39 318.228 382.666 318.3 381.968 318.161C381.27 318.022 380.628 317.679 380.125 317.176C379.621 316.672 379.278 316.031 379.139 315.332C379.001 314.634 379.072 313.91 379.344 313.252C379.617 312.595 380.078 312.032 380.67 311.637C381.262 311.241 381.958 311.03 382.67 311.03C383.143 311.03 383.611 311.123 384.048 311.304C384.485 311.485 384.882 311.75 385.216 312.084C385.55 312.419 385.815 312.816 385.996 313.252C386.177 313.689 386.27 314.157 386.27 314.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.84 314.78C383.84 315.017 383.77 315.249 383.638 315.447C383.506 315.644 383.319 315.798 383.1 315.889C382.88 315.98 382.639 316.003 382.406 315.957C382.174 315.911 381.96 315.796 381.792 315.629C381.624 315.461 381.51 315.247 381.463 315.014C381.417 314.781 381.441 314.54 381.532 314.321C381.623 314.102 381.776 313.914 381.974 313.782C382.171 313.65 382.403 313.58 382.64 313.58C382.959 313.58 383.264 313.707 383.489 313.932C383.714 314.157 383.84 314.462 383.84 314.78Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.29 358.46C413.29 359.172 413.079 359.868 412.683 360.46C412.288 361.052 411.725 361.514 411.067 361.786C410.41 362.059 409.686 362.13 408.988 361.991C408.289 361.852 407.648 361.509 407.144 361.006C406.641 360.502 406.298 359.861 406.159 359.162C406.02 358.464 406.091 357.74 406.364 357.082C406.636 356.425 407.098 355.862 407.69 355.467C408.282 355.071 408.978 354.86 409.69 354.86C410.645 354.86 411.56 355.239 412.235 355.915C412.911 356.59 413.29 357.505 413.29 358.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.89 358.63C410.89 358.867 410.82 359.099 410.688 359.297C410.556 359.494 410.369 359.648 410.149 359.739C409.93 359.829 409.689 359.853 409.456 359.807C409.223 359.761 409.01 359.646 408.842 359.478C408.674 359.311 408.56 359.097 408.513 358.864C408.467 358.631 408.491 358.39 408.582 358.171C408.672 357.951 408.826 357.764 409.024 357.632C409.221 357.5 409.453 357.43 409.69 357.43C410.008 357.43 410.314 357.556 410.539 357.781C410.764 358.006 410.89 358.312 410.89 358.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.23 361.63C394.23 362.342 394.019 363.038 393.624 363.63C393.228 364.222 392.666 364.684 392.008 364.956C391.35 365.228 390.626 365.3 389.928 365.161C389.23 365.022 388.588 364.679 388.085 364.176C387.581 363.672 387.238 363.031 387.099 362.332C386.961 361.634 387.032 360.91 387.304 360.252C387.577 359.595 388.038 359.032 388.63 358.637C389.222 358.241 389.918 358.03 390.63 358.03C391.103 358.03 391.571 358.123 392.008 358.304C392.445 358.485 392.842 358.75 393.176 359.084C393.51 359.419 393.775 359.816 393.956 360.252C394.137 360.689 394.23 361.157 394.23 361.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.84 361.77C391.84 362.007 391.77 362.239 391.638 362.437C391.506 362.634 391.319 362.788 391.1 362.879C390.88 362.97 390.639 362.993 390.406 362.947C390.174 362.901 389.96 362.786 389.792 362.619C389.624 362.451 389.51 362.237 389.463 362.004C389.417 361.771 389.441 361.53 389.532 361.311C389.623 361.092 389.776 360.904 389.974 360.772C390.171 360.64 390.403 360.57 390.64 360.57C390.959 360.57 391.264 360.696 391.489 360.922C391.714 361.147 391.84 361.452 391.84 361.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.39 390.88C406.39 391.592 406.179 392.288 405.784 392.88C405.388 393.472 404.826 393.934 404.168 394.206C403.51 394.478 402.786 394.55 402.088 394.411C401.39 394.272 400.748 393.929 400.245 393.426C399.741 392.922 399.399 392.281 399.26 391.582C399.121 390.884 399.192 390.16 399.464 389.502C399.737 388.845 400.198 388.282 400.79 387.887C401.382 387.491 402.078 387.28 402.79 387.28C403.745 387.28 404.661 387.659 405.336 388.334C406.011 389.01 406.39 389.925 406.39 390.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.98 391.03C403.98 391.267 403.91 391.499 403.778 391.697C403.646 391.894 403.459 392.048 403.239 392.139C403.02 392.23 402.779 392.253 402.546 392.207C402.313 392.161 402.099 392.046 401.932 391.879C401.764 391.711 401.649 391.497 401.603 391.264C401.557 391.031 401.581 390.79 401.671 390.571C401.762 390.352 401.916 390.164 402.113 390.032C402.311 389.9 402.543 389.83 402.78 389.83C403.098 389.83 403.404 389.957 403.629 390.182C403.854 390.407 403.98 390.712 403.98 391.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.44 311.93V309.35C410.44 309.35 410.69 308.63 411.04 308.56L414.58 308.48C414.941 308.652 415.22 308.956 415.36 309.33V311.99L410.48 311.91L410.44 311.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.49 308.41C411.49 308.41 411.31 306.98 411.49 306.83H414.07C414.25 306.98 414.16 308.42 414.16 308.42H411.49V308.41Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.21 313.93C376.21 313.93 376.21 312.49 376 312.37L373.44 312.68C373.28 312.85 373.57 314.27 373.57 314.27L376.21 313.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.69 317.36L377.42 314.79C377.42 314.79 377.08 314.1 376.73 314.07L373.21 314.37C373.04 314.471 372.892 314.606 372.775 314.766C372.659 314.925 372.575 315.107 372.53 315.3L372.85 317.94L377.69 317.34V317.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.71 364.38C381.71 364.38 381.71 365.82 381.92 365.94L384.48 365.63C384.64 365.46 384.35 364.04 384.35 364.04L381.71 364.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.23 360.95L380.5 363.51C380.5 363.51 380.84 364.2 381.19 364.23L384.71 363.92C384.881 363.819 385.029 363.684 385.145 363.524C385.262 363.365 385.346 363.183 385.39 362.99L385.07 360.35L380.23 360.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.41 358.03C419.41 358.03 419.27 359.46 419.46 359.6L422.04 359.55C422.21 359.39 422.04 357.95 422.04 357.95L419.38 358.02L419.41 358.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.5 353.87L396.03 356.63C396.93 361.36 405.43 360.72 404.59 355.17L404.16 352.47L395.51 353.88L395.5 353.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.66 355.76C401.66 356.043 401.576 356.319 401.419 356.555C401.262 356.79 401.038 356.973 400.777 357.081C400.516 357.189 400.228 357.218 399.951 357.163C399.673 357.107 399.419 356.971 399.219 356.771C399.019 356.571 398.882 356.316 398.827 356.039C398.772 355.762 398.8 355.474 398.909 355.213C399.017 354.952 399.2 354.728 399.435 354.571C399.67 354.414 399.947 354.33 400.23 354.33C400.418 354.33 400.604 354.367 400.777 354.439C400.951 354.511 401.108 354.616 401.241 354.749C401.374 354.882 401.479 355.039 401.551 355.213C401.623 355.386 401.66 355.572 401.66 355.76Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.84 320.94L389.45 318.16C388.78 313.39 397.03 311.25 398.02 316.78L398.48 319.48L389.84 320.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.01 317.16C394.92 316.892 394.752 316.657 394.527 316.484C394.303 316.311 394.032 316.209 393.749 316.191C393.467 316.172 393.185 316.238 392.94 316.38C392.695 316.521 392.497 316.733 392.372 316.987C392.247 317.241 392.201 317.526 392.238 317.807C392.276 318.088 392.396 318.351 392.583 318.563C392.77 318.776 393.016 318.928 393.29 319C393.564 319.073 393.853 319.062 394.12 318.97C394.298 318.91 394.462 318.816 394.603 318.693C394.745 318.569 394.86 318.419 394.943 318.251C395.025 318.082 395.074 317.899 395.086 317.712C395.097 317.525 395.072 317.337 395.01 317.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.03 382.93H327.73V380.23L329.68 377.98L329.83 374.53L325.18 374.23L325.03 382.94V382.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.99 372.72L327.59 372.42L327.74 366.87L330.14 367.02L329.99 372.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.84 374.37V372.42V374.37Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.84 374.37V372.42",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.94 366.87L329.09 365.37L328.94 366.87Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.94 366.87L329.09 365.37",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3301 264.32H52.0801V319.71H57.3301V264.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4203 321.35H23.1104V325.1H44.4203V321.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7197 382.38C42.8197 389.28 51.5297 389.06 53.9297 382.53L55.0597 378.18",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7197 382.38C42.8197 389.28 51.5297 389.06 53.9297 382.53L55.0597 378.18",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.21 475.63H40.64L40.72 381.22L27.21 381.07V475.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8397 475.74L37.6697 381.18H27.2197V475.63L37.8297 475.71L37.8397 475.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3205 377.94H23.2305V381.39H44.3205V377.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8798 324.36H9.2998V378.55H59.8798V324.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6396 327.81H11.5596V375.09H57.6396V327.81Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9398 366.69C21.9398 367.347 21.7451 367.989 21.3803 368.535C21.0155 369.081 20.497 369.506 19.8903 369.757C19.2837 370.009 18.6161 370.074 17.9721 369.946C17.3281 369.818 16.7365 369.502 16.2722 369.038C15.8079 368.573 15.4917 367.982 15.3636 367.338C15.2355 366.694 15.3012 366.026 15.5525 365.42C15.8038 364.813 16.2293 364.294 16.7753 363.93C17.3213 363.565 17.9632 363.37 18.6198 363.37C19.5003 363.37 20.3448 363.72 20.9674 364.343C21.59 364.965 21.9398 365.81 21.9398 366.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9496 366.69C33.9496 367.347 33.7549 367.989 33.3901 368.535C33.0252 369.081 32.5067 369.506 31.9001 369.757C31.2934 370.009 30.6259 370.074 29.9819 369.946C29.3379 369.818 28.7463 369.502 28.282 369.038C27.8177 368.573 27.5015 367.982 27.3734 367.338C27.2453 366.694 27.311 366.026 27.5623 365.42C27.8136 364.813 28.2391 364.294 28.7851 363.93C29.331 363.565 29.9729 363.37 30.6296 363.37C31.5101 363.37 32.3545 363.72 32.9772 364.343C33.5998 364.965 33.9496 365.81 33.9496 366.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9603 366.69C45.9603 367.347 45.7656 367.989 45.4008 368.535C45.036 369.081 44.5175 369.506 43.9108 369.757C43.3042 370.009 42.6366 370.074 41.9926 369.946C41.3486 369.818 40.757 369.502 40.2927 369.038C39.8284 368.573 39.5122 367.982 39.3841 367.338C39.256 366.694 39.3218 366.026 39.573 365.42C39.8243 364.813 40.2498 364.294 40.7958 363.93C41.3418 363.565 41.9837 363.37 42.6403 363.37C43.5208 363.37 44.3653 363.72 44.9879 364.343C45.6105 364.965 45.9603 365.81 45.9603 366.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2704 331.42H55.7004C56.0186 331.42 56.3238 331.546 56.5489 331.771C56.7739 331.996 56.9003 332.302 56.9003 332.62V357.24C56.9003 357.558 56.7739 357.863 56.5489 358.088C56.3238 358.313 56.0186 358.44 55.7004 358.44H14.2704C13.9521 358.44 13.6469 358.313 13.4218 358.088C13.1968 357.863 13.0704 357.558 13.0704 357.24V332.63C13.069 332.471 13.0991 332.314 13.1588 332.168C13.2185 332.021 13.3067 331.887 13.4183 331.775C13.5298 331.662 13.6626 331.573 13.8088 331.512C13.9551 331.451 14.1119 331.42 14.2704 331.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2398 334.26H15.0098V356.17H55.2398V334.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3398 319.41H58.8398C59.1581 319.41 59.4633 319.536 59.6883 319.761C59.9134 319.986 60.0398 320.292 60.0398 320.61V323.01C60.0398 323.328 59.9134 323.633 59.6883 323.858C59.4633 324.083 59.1581 324.21 58.8398 324.21H51.3398C51.0216 324.21 50.7163 324.083 50.4913 323.858C50.2662 323.633 50.1398 323.328 50.1398 323.01V320.63C50.1372 320.471 50.1662 320.312 50.2254 320.165C50.2845 320.017 50.3724 319.882 50.4841 319.768C50.5958 319.655 50.729 319.565 50.8759 319.503C51.0228 319.442 51.1805 319.41 51.3398 319.41Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8404 256.97H57.3404C57.9769 256.97 58.5874 257.223 59.0375 257.673C59.4876 258.123 59.7404 258.733 59.7404 259.37V262.52C59.7404 263.156 59.4876 263.767 59.0375 264.217C58.5874 264.667 57.9769 264.92 57.3404 264.92H52.8404C52.2039 264.92 51.5935 264.667 51.1434 264.217C50.6933 263.767 50.4404 263.156 50.4404 262.52V259.37C50.4404 258.733 50.6933 258.123 51.1434 257.673C51.5935 257.223 52.2039 256.97 52.8404 256.97Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4296 260.41H22.8096",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1299 246V274.22",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2305 248.48V271.9",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.29 251.52V269.01",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.46 255.16V266.68",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8604 257.56V263.23",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6201 258.76V262.22",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5104 416.39H91.6304L108.57 456.17L76.1904 456.09L76.5104 416.38V416.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4697 414.15L105.06 413.77L105.21 416.92L76.3896 416.39L76.4697 414.14V414.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5498 416.55V390.81L105.37 378.63L105.22 416.75L76.5498 416.52V416.55Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.84 428.82C134.84 431.88 134.238 434.91 133.067 437.737C131.896 440.563 130.179 443.132 128.016 445.296C125.852 447.459 123.284 449.175 120.457 450.346C117.63 451.517 114.6 452.12 111.54 452.12C108.48 452.12 105.451 451.517 102.624 450.346C99.7968 449.175 97.2283 447.459 95.0647 445.296C92.901 443.132 91.1848 440.563 90.0138 437.737C88.8429 434.91 88.2402 431.88 88.2402 428.82C88.2402 425.76 88.8429 422.73 90.0138 419.904C91.1848 417.077 92.901 414.508 95.0647 412.344C97.2283 410.181 99.7968 408.465 102.624 407.294C105.451 406.123 108.48 405.52 111.54 405.52C114.6 405.52 117.63 406.123 120.457 407.294C123.284 408.465 125.852 410.181 128.016 412.344C130.179 414.508 131.896 417.077 133.067 419.904C134.238 422.73 134.84 425.76 134.84 428.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.03 428.78C131.03 432.625 129.89 436.383 127.754 439.58C125.618 442.777 122.582 445.269 119.03 446.74C115.478 448.212 111.569 448.597 107.798 447.846C104.027 447.096 100.563 445.245 97.8442 442.526C95.1255 439.807 93.274 436.344 92.5239 432.573C91.7738 428.802 92.1588 424.893 93.6302 421.341C95.1015 417.788 97.5932 414.752 100.79 412.616C103.987 410.48 107.746 409.34 111.59 409.34C116.746 409.34 121.691 411.388 125.337 415.034C128.982 418.68 131.03 423.624 131.03 428.78Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.17 443.23C113.17 443.564 113.071 443.891 112.885 444.169C112.7 444.447 112.436 444.663 112.127 444.791C111.818 444.919 111.478 444.953 111.15 444.888C110.823 444.822 110.521 444.661 110.285 444.425C110.049 444.189 109.888 443.888 109.823 443.56C109.757 443.232 109.791 442.892 109.919 442.583C110.047 442.275 110.263 442.011 110.541 441.825C110.819 441.639 111.146 441.54 111.48 441.54C111.928 441.54 112.358 441.718 112.675 442.035C112.992 442.352 113.17 442.782 113.17 443.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.17 429.23C98.17 429.564 98.0709 429.891 97.8852 430.169C97.6995 430.447 97.4356 430.663 97.1268 430.791C96.818 430.919 96.4782 430.953 96.1503 430.888C95.8225 430.822 95.5214 430.661 95.285 430.425C95.0487 430.189 94.8877 429.888 94.8225 429.56C94.7573 429.232 94.7908 428.892 94.9187 428.583C95.0466 428.275 95.2632 428.011 95.5411 427.825C95.819 427.639 96.1458 427.54 96.48 427.54C96.9283 427.54 97.3581 427.718 97.6751 428.035C97.992 428.352 98.17 428.782 98.17 429.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.84 428.82C127.84 429.154 127.741 429.481 127.555 429.759C127.369 430.037 127.106 430.253 126.797 430.381C126.488 430.509 126.148 430.543 125.82 430.478C125.492 430.412 125.191 430.251 124.955 430.015C124.719 429.779 124.558 429.478 124.492 429.15C124.427 428.822 124.461 428.482 124.589 428.173C124.717 427.864 124.933 427.601 125.211 427.415C125.489 427.229 125.816 427.13 126.15 427.13C126.598 427.13 127.028 427.308 127.345 427.625C127.662 427.942 127.84 428.372 127.84 428.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.84 414.82C112.84 415.154 112.741 415.481 112.555 415.759C112.369 416.037 112.106 416.253 111.797 416.381C111.488 416.509 111.148 416.543 110.82 416.478C110.492 416.412 110.191 416.251 109.955 416.015C109.719 415.779 109.558 415.478 109.492 415.15C109.427 414.822 109.461 414.482 109.589 414.173C109.717 413.864 109.933 413.601 110.211 413.415C110.489 413.229 110.816 413.13 111.15 413.13C111.598 413.13 112.028 413.308 112.345 413.625C112.662 413.942 112.84 414.372 112.84 414.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.36 456.25L148.31 459.17L55.1797 459.43V456.25H148.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1299 452.69L76.7199 452.56V455.56H63.1299V452.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5696 454.38H76.3896V456.61H79.5696V454.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4697 453.01H107.6V455.82H91.5197L91.4697 453.01Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8304 454.12H88.6504V456.35H91.8304V454.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1203 451.09H80.1104V455.02H88.1203V451.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0102 448.07H81.4902V450.72H87.0102V448.07Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2797 451.37H59.5297V455.93H55.1797L55.2897 451.37H55.2797Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2598 450.52V463.04V450.52Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2598 450.52V463.04",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.15 341.09L324.65 341.3L327.09 355.3L330.49 354.45L328.16 341.08L328.15 341.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.51 341.09C325.93 342.68 327.95 353.72 334.1 352.98L354.05 350.54L352.56 338.44L332.5 341.09H332.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.92 346.88C337.92 347.753 337.573 348.589 336.956 349.206C336.339 349.823 335.502 350.17 334.63 350.17C333.757 350.17 332.92 349.823 332.303 349.206C331.686 348.589 331.34 347.753 331.34 346.88C331.34 346.008 331.686 345.171 332.303 344.554C332.92 343.937 333.757 343.59 334.63 343.59C335.502 343.59 336.339 343.937 336.956 344.554C337.573 345.171 337.92 346.008 337.92 346.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.67 345.82C345.67 346.693 345.323 347.529 344.706 348.146C344.089 348.763 343.252 349.11 342.38 349.11C341.507 349.11 340.67 348.763 340.053 348.146C339.436 347.529 339.09 346.693 339.09 345.82C339.09 344.947 339.436 344.111 340.053 343.494C340.67 342.877 341.507 342.53 342.38 342.53C343.252 342.53 344.089 342.877 344.706 343.494C345.323 344.111 345.67 344.947 345.67 345.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.3 354.47V357.05C418.3 357.05 418.57 357.77 418.92 357.84L422.46 357.9C422.82 357.726 423.097 357.417 423.23 357.04V354.38L418.35 354.48L418.3 354.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.56 323.47L356.28 319.63L368.59 338.63C374.32 353.63 352.78 360.71 347.79 345.95L345.56 323.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.84 342.83C364.84 344.464 364.191 346.03 363.035 347.186C361.88 348.341 360.313 348.99 358.68 348.99C357.046 348.99 355.479 348.341 354.324 347.186C353.169 346.03 352.52 344.464 352.52 342.83C352.52 341.196 353.169 339.629 354.324 338.474C355.479 337.319 357.046 336.67 358.68 336.67C360.313 336.67 361.88 337.319 363.035 338.474C364.191 339.629 364.84 341.196 364.84 342.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.77 340.45C351.77 340.818 351.661 341.178 351.456 341.483C351.252 341.789 350.961 342.028 350.622 342.169C350.282 342.309 349.908 342.346 349.547 342.274C349.186 342.203 348.855 342.025 348.595 341.765C348.334 341.505 348.157 341.174 348.086 340.813C348.014 340.452 348.051 340.078 348.191 339.738C348.332 339.398 348.571 339.108 348.876 338.904C349.182 338.699 349.542 338.59 349.91 338.59C350.403 338.59 350.876 338.786 351.225 339.135C351.574 339.484 351.77 339.957 351.77 340.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.31 335.35C365.31 335.718 365.201 336.077 364.996 336.383C364.792 336.689 364.501 336.928 364.162 337.068C363.822 337.209 363.448 337.246 363.087 337.174C362.726 337.102 362.395 336.925 362.135 336.665C361.874 336.405 361.697 336.074 361.626 335.713C361.554 335.352 361.591 334.978 361.731 334.638C361.872 334.298 362.111 334.008 362.416 333.803C362.722 333.599 363.082 333.49 363.45 333.49C363.943 333.49 364.416 333.686 364.765 334.035C365.114 334.384 365.31 334.857 365.31 335.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.68 351.04C363.68 351.408 363.571 351.767 363.366 352.073C363.162 352.379 362.872 352.618 362.532 352.758C362.192 352.899 361.818 352.936 361.457 352.864C361.096 352.792 360.765 352.615 360.505 352.355C360.245 352.095 360.067 351.764 359.996 351.403C359.924 351.042 359.961 350.668 360.102 350.328C360.242 349.988 360.481 349.698 360.787 349.493C361.092 349.289 361.452 349.18 361.82 349.18C362.313 349.18 362.786 349.376 363.135 349.725C363.484 350.074 363.68 350.547 363.68 351.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.06 342.83C362.06 343.703 361.714 344.539 361.097 345.156C360.48 345.773 359.643 346.12 358.77 346.12C357.898 346.12 357.061 345.773 356.444 345.156C355.827 344.539 355.48 343.703 355.48 342.83C355.48 342.398 355.566 341.97 355.731 341.571C355.896 341.172 356.139 340.809 356.444 340.504C356.75 340.198 357.112 339.956 357.511 339.79C357.911 339.625 358.338 339.54 358.77 339.54C359.202 339.54 359.63 339.625 360.029 339.79C360.429 339.956 360.791 340.198 361.097 340.504C361.402 340.809 361.645 341.172 361.81 341.571C361.975 341.97 362.06 342.398 362.06 342.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.09 469.97H650.58L650.47 488.97L600.03 498.71V469.98L600.09 469.97Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.52 497.11V515.71L642.28 508.43V490.49L608.52 497.11Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.91 513.53V564.63L625.31 554.73L631.31 559V510.91L618.95 513.54L618.91 513.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.57 515.63V735.54V515.63Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.57 515.63V735.54",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.3 735.42V726.78H610.98V582.63H608.55",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.3 735.42V726.78H610.98V582.63H608.55",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.48 571.89L630.17 576.58V625.51H631.75V637.82H618.84V625.44H620.49V578.5L625.44 571.9L625.48 571.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.03 714.78H619.55H611.03Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.03 714.78H619.55",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.33 720.26C631.33 721.447 630.978 722.607 630.319 723.593C629.66 724.58 628.723 725.349 627.626 725.803C626.53 726.257 625.323 726.376 624.16 726.145C622.996 725.913 621.927 725.342 621.087 724.503C620.248 723.664 619.677 722.594 619.445 721.431C619.214 720.267 619.333 719.06 619.787 717.964C620.241 716.868 621.01 715.93 621.997 715.271C622.983 714.612 624.143 714.26 625.33 714.26C626.921 714.26 628.448 714.892 629.573 716.017C630.698 717.143 631.33 718.669 631.33 720.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.21 582.63H639.66V726.79H631.37V735.16",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.21 582.63H639.66V726.79H631.37V735.16",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.47 639.85L612.12 646.38V687.81L619.12 690.81",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.47 639.85L612.12 646.38V687.81L619.12 690.81",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.33 639.85L638.68 646.38V687.81L631.68 690.81",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.33 639.85L638.68 646.38V687.81L631.68 690.81",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.29 670.24L638.72 672.68L631.29 670.24Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.29 670.24L638.72 672.68",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.37 685.63C631.37 686.817 631.018 687.977 630.359 688.963C629.7 689.95 628.763 690.719 627.666 691.173C626.57 691.627 625.363 691.746 624.2 691.515C623.036 691.283 621.967 690.712 621.127 689.873C620.288 689.034 619.717 687.964 619.485 686.801C619.254 685.637 619.373 684.43 619.827 683.334C620.281 682.238 621.05 681.3 622.037 680.641C623.023 679.982 624.183 679.63 625.37 679.63C626.961 679.63 628.488 680.262 629.613 681.387C630.738 682.513 631.37 684.039 631.37 685.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.96 714.78H639.48H630.96Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.96 714.78H639.48",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.51 670.24L612.08 672.68L619.51 670.24Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.51 670.24L612.08 672.68",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.45 419.19C678.45 420.667 677.863 422.084 676.818 423.129C675.774 424.173 674.357 424.76 672.88 424.76C671.402 424.76 669.986 424.173 668.941 423.129C667.896 422.084 667.31 420.667 667.31 419.19C667.31 417.713 667.896 416.296 668.941 415.251C669.986 414.207 671.402 413.62 672.88 413.62C674.357 413.62 675.774 414.207 676.818 415.251C677.863 416.296 678.45 417.713 678.45 419.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.46 419.7L677 419.62L678.46 419.7Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.46 419.7L677 419.62",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.45 419.19C678.45 420.667 677.863 422.084 676.818 423.129C675.774 424.173 674.357 424.76 672.88 424.76C671.402 424.76 669.986 424.173 668.941 423.129C667.896 422.084 667.31 420.667 667.31 419.19C667.31 417.713 667.896 416.296 668.941 415.251C669.986 414.207 671.402 413.62 672.88 413.62C674.357 413.62 675.774 414.207 676.818 415.251C677.863 416.296 678.45 417.713 678.45 419.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.1 421.72L669.53 421.11L668.1 421.72Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.1 421.72L669.53 421.11",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.41 419.7L668.84 419.63L667.41 419.7Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.41 419.7L668.84 419.63",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.7 417.39L669 417.84L667.7 417.39Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.7 417.39L669 417.84",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.92 415.35L669.92 416.35L668.92 415.35Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.92 415.35L669.92 416.35",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.84 420.16L669.23 415.9L670.37 414.98L673.78 419.29L672.85 420.16H672.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.67 414.05L671.23 415.32L670.67 414.05Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.67 414.05L671.23 415.32",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.84 419.24C673.853 419.363 673.84 419.487 673.802 419.604C673.764 419.722 673.702 419.83 673.62 419.922C673.537 420.014 673.436 420.087 673.323 420.137C673.211 420.188 673.088 420.214 672.965 420.214C672.841 420.214 672.719 420.188 672.607 420.137C672.494 420.087 672.393 420.014 672.31 419.922C672.228 419.83 672.166 419.722 672.128 419.604C672.09 419.487 672.077 419.363 672.09 419.24C672.077 419.117 672.09 418.993 672.128 418.876C672.166 418.758 672.228 418.65 672.31 418.558C672.393 418.466 672.494 418.393 672.607 418.343C672.719 418.292 672.841 418.266 672.965 418.266C673.088 418.266 673.211 418.292 673.323 418.343C673.436 418.393 673.537 418.466 673.62 418.558C673.702 418.65 673.764 418.758 673.802 418.876C673.84 418.993 673.853 419.117 673.84 419.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.93 413.63V415.01V413.63Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.93 413.63V415.01",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.77 421.72L676.34 421.11L677.77 421.72Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.77 421.72L676.34 421.11",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.17 417.39L676.87 417.84L678.17 417.39Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.17 417.39L676.87 417.84",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.95 415.35L675.95 416.35L676.95 415.35Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.95 415.35L675.95 416.35",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.2 414.05L674.64 415.32L675.2 414.05Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.2 414.05L674.64 415.32",
    stroke: "#F7F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_4426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3058_4426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 843.84,
    height: 677.84,
    fill: "white",
    transform: "translate(-47 92)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetPump);
export default __webpack_public_path__ + "static/media/jet-pump.3397580731422cf8588afdc68e22004b.svg";
export { ForwardRef as ReactComponent };